import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { Company } from "../types";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createCompany } from "../api/createCompany";


export const useCreateCompany = (): UseMutationResult<ApiResponse<Company>, ApiError, Company> => {
    return useMutation({
        mutationFn: createCompany,
        onSuccess: ({ data }) => {
        },
        onError: () => {

        }
    })
}